
const CTA = () => {
  return (
    <section id="contact" className="py-24 bg-[#001E3C] relative overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-[#00D9C9]/10 via-transparent to-[#0066FF]/10"></div>
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#00D9C9]/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#0066FF]/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="max-w-[1200px] mx-auto px-6 lg:px-12 relative z-10">
        <div className="bg-gradient-to-br from-[#00D9C9] to-[#0099B3] rounded-2xl p-12 lg:p-16 relative overflow-hidden">
          {/* Decorative Pattern */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute inset-0" style={{
              backgroundImage: `
                linear-gradient(90deg, #001E3C 1px, transparent 1px),
                linear-gradient(0deg, #001E3C 1px, transparent 1px)
              `,
              backgroundSize: '40px 40px'
            }}></div>
          </div>

          <div className="relative z-10 text-center max-w-3xl mx-auto">
            {/* Icon */}
            <div className="inline-flex items-center justify-center w-20 h-20 bg-[#001E3C] rounded-full mb-8">
              <i className="ri-customer-service-2-line text-4xl text-[#00D9C9]"></i>
            </div>

            {/* Heading */}
            <h2 className="text-4xl lg:text-5xl font-bold text-[#001E3C] mb-6">
              Ready to Transform Your Manufacturing?
            </h2>

            {/* Description */}
            <p className="text-xl text-[#001E3C]/80 mb-10 leading-relaxed">
              Connect with our experts to discover how our advanced drilling solutions can elevate your production capabilities and drive innovation in your industry.
            </p>

            {/* CTA Button */}
            <div className="flex justify-center">
              <a
                href="mailto:info@hi-tak.co.jp?subject=Inquiry from Hi-Tak Website"
                className="group bg-[#001E3C] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#002A4E] transition-all duration-300 text-lg flex items-center justify-center gap-2 whitespace-nowrap"
              >
                Get Started
                <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform w-6 h-6 flex items-center justify-center"></i>
              </a>
            </div>

            {/* Contact Info */}
            <div className="grid sm:grid-cols-3 gap-6 mt-12 pt-8 border-t border-[#001E3C]/20">
              <div className="flex items-center justify-center gap-3">
                <i className="ri-phone-line text-2xl text-[#001E3C] w-6 h-6 flex items-center justify-center"></i>
                <span className="text-[#001E3C] font-semibold">+81-55-939-5581</span>
              </div>
              <div className="flex items-center justify-center gap-3">
                <i className="ri-mail-line text-2xl text-[#001E3C] w-6 h-6 flex items-center justify-center"></i>
                <span className="text-[#001E3C] font-semibold">info@hi-tak.co.jp</span>
              </div>
              <div className="flex items-center justify-center gap-3">
                <i className="ri-time-line text-2xl text-[#001E3C] w-6 h-6 flex items-center justify-center"></i>
                <span className="text-[#001E3C] font-semibold">24/7 Support</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
